/**
 * Corpus stats — single source for BOTH renderings (the hero proof ribbon and
 * the full stats ledger), so the numbers can never drift apart. Real corpus
 * figures only: no invented numbers even on marketing surfaces.
 *
 * Provenance — re-verify before changing any number:
 * - HC / SC judgments: BigQuery corpora. Environment topology (per product
 *   owner, 2026-08-10): ia_dev = united-embassy-399319 is THE current
 *   environment and promotes into the new ia_prod; gen-lang-client-0804431885
 *   is the OLD dev env — its stale corpus is NOT authoritative. Verified
 *   2026-08-10: ia_dev hc_judgments = 17,360,332 (1.74 Cr; ingest still
 *   growing toward ~1.9 Cr), sc_judgments = 42,858. "1.7 Cr+" is a floor
 *   under the verified count; bump when the ingest completes. Re-check:
 *   bq --project_id=united-embassy-399319 show --format=json nyayabodh.hc_judgments
 * - 1,085 = BNS 384 + BNSS 531 + BSA 170 indexed sections; 570 IPC→BNS from
 *   the canonical Government concordance seed.
 * - 523 civil sections = CPA 107 + CPA Rules 44 + Chit Funds 90 +
 *   Arbitration 113 + Limitation 169 (data/processed/<act>/*.md) — DEPLOYED
 *   civil acts only. Contract Act / NI Act / CPC Orders corpora exist on disk
 *   but ship with the civil-suit-spine; add them here only when that is live.
 * - 48 corporate acts & rules across 11 families: backend/scripts/
 *   act_registry.json (the registry driving live corporate research).
 */

export interface CorpusStat {
  value: string;
  /** Full label — the stats ledger's small-caps line. */
  label: string;
  /** Compact label — the hero proof ribbon. */
  short: string;
}

export const CORPUS_STATS: CorpusStat[] = [
  {
    // Crore, not millions: the audience thinks in Indian numeration.
    value: '1.7 Cr+',
    label: 'SC & HIGH COURT JUDGMENTS · EVERY PRACTICE',
    short: 'JUDGMENTS',
  },
  {
    value: '1,085',
    label: 'CRIMINAL · BNS · BNSS · BSA + 570 IPC→BNS',
    short: 'CRIMINAL SECTIONS',
  },
  {
    value: '523',
    label: 'CIVIL · CPA · ARBITRATION · LIMITATION SECTIONS',
    short: 'CIVIL SECTIONS',
  },
  {
    value: '48 ACTS',
    label: 'CORPORATE · COMPANIES · SEBI · IBC · FEMA',
    short: 'CORPORATE',
  },
];
